import done from '../../assets/photonobackground.png'
const Img = () => {
    return ( 
        <div className="img">
            <img src={done} alt="me" />
        </div>
     );
}
 
export default Img;